import { css } from 'linaria';

export const rootTreeStyle = css`
    ul {
        padding: 0;
        margin: 0;
    }
`;

export const rootNodeStyle = css`
    list-style-type: none;
    text-align: left;
    width: 100%;
    background-color: #292f33;

    label {
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        display: block;
        text-align: start;
    }
`;

export const treeNodeStyle = css`
    height: 50px;
    padding: 0 0.75rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: white;
    box-shadow: none;
    z-index: unset;
    position: relative;
`;

export const treeNodeSelectedStyle = css`
    color: white;
    background-color: rgba(255, 255, 255, 0.16);

    &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 4px;
        border-left: 4px solid #ff5500;
    }

    &:focus-visible {
        background-color: rgba(255, 255, 255, 0.16);
        outline: none;
    }
`;

export const triggerArrowIcon = css`
    height: 1.5em;
    width: 1.5em;
    transition: all 0.2s ease-in;
    margin-right: 4px;
`;

export const rightActionIcon = css`
    height: 1.25em;
    width: 1.25em;
`;

export const rotateIcon = css`
    transform: rotate(90deg);
`;

export const triggerButton = css`
    width: 100%;
    padding: 0;
    border: none;
    background-color: #292f33;

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
    }
    &:focus-visible {
        background-color: rgba(255, 255, 255, 0.32);
        outline: none;
    }
    &:active {
        background-color: rgba(255, 255, 255, 0.32);
    }
`;

export const triggerButtonSelected = css`
    width: 100%;
    padding: 0;
    border: none;
    background-color: #292f33;

    &:focus-visible {
        outline: none;
    }
`;

export const nodeLabelStyle = css`
    display: flex;
    flex: 1;
    align-items: center;
`;

export const nodeLabelNoIcon = css`
    &:before {
        content: '•';
        width: 1.5em;
        height: 1.5em;
        margin-right: 0.5em;
    }
`;

export const actionButton = css`
    all: unset;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    opacity: 0.5;

    &:hover {
        opacity: 1;
        background-color: #5a5e62;
    }
    &:active {
        opacity: 1;
        background-color: #85888b;
    }
`;

export const actionButtonHidden = css`
    all: unset;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    opacity: 0;
`;
